webpackJsonp([70144966829960],{

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(39);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _favicon = __webpack_require__(54);
	
	var _favicon2 = _interopRequireDefault(_favicon);
	
	var _favicon3 = __webpack_require__(55);
	
	var _favicon4 = _interopRequireDefault(_favicon3);
	
	var _favicon5 = __webpack_require__(56);
	
	var _favicon6 = _interopRequireDefault(_favicon5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactPage = function ContactPage() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'section contact-section has-text-centered' },
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Contact Rekon Technologies',
	      meta: [{ name: 'description', content: 'Contact Rekon Technologies' }],
	      link: [{ rel: "icon", type: "image/png", sizes: "16x16", href: '' + _favicon2.default }, { rel: "icon", type: "image/png", sizes: "32x32", href: '' + _favicon4.default }, { rel: "shortcut icon", type: "image/png", href: '' + _favicon6.default }]
	    }),
	    _react2.default.createElement(
	      'h1',
	      { className: 'title fg-primary' },
	      'We Are Here to Help'
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'columns' },
	        _react2.default.createElement(
	          'div',
	          { className: 'column' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'title' },
	            'Sales'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            '(626) 577-4350 ',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'a',
	              { href: 'mailto:sales@rekon.com' },
	              'sales@rekon.com'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'column' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'title' },
	            'Support'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            '(626) 577-4350 ',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'a',
	              { href: 'mailto:techsupport@rekon.com' },
	              'techsupport@rekon.com'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'column' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'title' },
	            'Address'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            '100 W. Broadway, Suite 920 ',
	            _react2.default.createElement('br', null),
	            'Glendale, CA 91210'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = ContactPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-7121c998ad996b41b59e.js